import p from "clsx";
import * as l from "react";
import { useMemo as P, createElement as J, useCallback as R, useRef as Q, useState as B, useEffect as Z, memo as G } from "react";
import { jsx as a, jsxs as f } from "react/jsx-runtime";
import { useCopyToClipboard as z, useKeyPressEvent as D } from "react-use";
import { g as tt } from "./_baseToString-CcsvGzgN.mjs";
import "date-fns";
import "date-fns/locale";
import "next/headers";
import { C as et } from "./Content-DQidYhT2.mjs";
import S from "animejs";
import { u as nt, a as ot } from "./useActiveHeadingObserver-CH1gP7YJ.mjs";
import "next/link";
import "next-i18n-router/client";
import "body-scroll-lock";
const st = "Row-module_row__95FJZ", at = "Row-module_rowMobile__4iTXp", ct = "Row-module_alignCenter__rY9bs", rt = "Row-module_withContainer__RPR0p", g = {
  row: st,
  rowMobile: at,
  alignCenter: ct,
  withContainer: rt
};
function ee({
  className: e,
  children: t,
  element: n = "div",
  mobileGrid: o = !1,
  alignCenter: c,
  innerHtml: r,
  desktopColumnsCount: i,
  fluid: u = !1
}) {
  const m = P(() => i ? {
    "--desktopColumnsCount": i
  } : {}, [i]);
  return J(
    n,
    {
      className: p(
        e,
        g.row,
        o && g.rowMobile,
        c && g.alignCenter,
        !u && g.withContainer
      ),
      style: m,
      dangerouslySetInnerHTML: r ? { __html: r } : void 0
    },
    t
  );
}
const lt = ({ size: e = 200, color: t = "currentColor", className: n, ...o }) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: n,
    ...o,
    children: /* @__PURE__ */ a(
      "circle",
      {
        cx: "50",
        cy: "50",
        fill: "none",
        stroke: t,
        strokeWidth: "10",
        r: "35",
        strokeDasharray: "164.93361431346415 56.97787143782138",
        transform: "matrix(1, 0, 0, 1, 0, 0)",
        children: /* @__PURE__ */ a(
          "animateTransform",
          {
            attributeName: "transform",
            type: "rotate",
            repeatCount: "indefinite",
            dur: "1s",
            keyTimes: "0;1",
            values: "0 50 50;360 50 50"
          }
        )
      }
    )
  }
), it = "Loader-module_loader__Ukoov", ut = {
  loader: it
};
function pt({ className: e }) {
  return /* @__PURE__ */ a(lt, { className: p(ut.loader, e) });
}
const mt = "Button-module_btn__daEdK", dt = "Button-module_outline__TFr94", ht = "Button-module_loading__QfItr", _t = "Button-module_spin__kQKH9", vt = "Button-module_btnContent__ydXzc", ft = "Button-module_content__PpYVU", bt = "Button-module_loader__KKJJD", h = {
  btn: mt,
  outline: dt,
  loading: ht,
  spin: _t,
  btnContent: vt,
  content: ft,
  loader: bt,
  "btn-xs": "Button-module_btn-xs__R9haU",
  "btn-sm": "Button-module_btn-sm__KNlkv",
  "btn-md": "Button-module_btn-md__C8vqh",
  "btn-lg": "Button-module_btn-lg__zDd8X",
  "btn-primary": "Button-module_btn-primary__vwY5K",
  "btn-secondary": "Button-module_btn-secondary__w3xYM",
  "btn-success": "Button-module_btn-success__vIh-I",
  "btn-transparent": "Button-module_btn-transparent__nY-p4"
};
function wt({
  size: e,
  color: t = "success",
  outline: n = !1,
  loading: o = !1,
  className: c,
  children: r,
  ...i
}) {
  const u = p(
    h.btn,
    h[`btn-${t}`],
    {
      [h[`btn-${e}`]]: e,
      [h.outline]: n,
      [h.loading]: o
    },
    c
  );
  return /* @__PURE__ */ f("button", { className: u, ...i, children: [
    /* @__PURE__ */ a("span", { className: h.content, children: r }),
    o && /* @__PURE__ */ a(pt, { className: h.loader })
  ] });
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var d = function() {
  return d = Object.assign || function(t) {
    for (var n, o = 1, c = arguments.length; o < c; o++) {
      n = arguments[o];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, d.apply(this, arguments);
};
function yt(e, t) {
  var n = l.useState(!1), o = n[0], c = n[1], r = l.useState(e.alwaysLoadIframe || !1), i = r[0], u = r[1], m = encodeURIComponent(e.id), v = typeof e.playlistCoverId == "string" ? encodeURIComponent(e.playlistCoverId) : null, b = e.title, w = e.poster || "hqdefault", M = e.announce || "Watch", k = new URLSearchParams(d(d(d(d({}, e.muted ? { mute: "1" } : {}), e.alwaysLoadIframe ? {} : { autoplay: "1", state: "1" }), e.enableJsApi ? { enablejsapi: "1" } : {}), e.playlist ? { list: m } : {})), y = e.noCookie ? "https://www.youtube-nocookie.com" : "https://www.youtube.com";
  y = e.cookie ? "https://www.youtube.com" : "https://www.youtube-nocookie.com";
  var F = e.playlist ? "".concat(y, "/embed/videoseries?").concat(k.toString()) : "".concat(y, "/embed/").concat(m, "?").concat(k.toString()), E = e.webp ? "webp" : "jpg", I = e.webp ? "vi_webp" : "vi", x = e.thumbnail || (e.playlist ? "https://i.ytimg.com/".concat(I, "/").concat(v, "/").concat(w, ".").concat(E) : "https://i.ytimg.com/".concat(I, "/").concat(m, "/").concat(w, ".").concat(E)), H = e.activatedClass || "lyt-activated", L = e.adNetwork || !1, U = e.aspectHeight || 9, $ = e.aspectWidth || 16, O = e.iframeClass || "", A = e.playerClass || "lty-playbtn", W = e.wrapperClass || "yt-lite", j = e.onIframeAdded || function() {
  }, q = e.rel ? "prefetch" : "preload", K = e.containerElement || "article", V = e.style || {}, Y = function() {
    o || c(!0);
  }, X = function() {
    i || u(!0);
  };
  return l.useEffect(function() {
    i && j();
  }, [i]), l.createElement(
    l.Fragment,
    null,
    l.createElement("link", { rel: q, href: x, as: "image" }),
    l.createElement(l.Fragment, null, o && l.createElement(
      l.Fragment,
      null,
      l.createElement("link", { rel: "preconnect", href: y }),
      l.createElement("link", { rel: "preconnect", href: "https://www.google.com" }),
      L && l.createElement(
        l.Fragment,
        null,
        l.createElement("link", { rel: "preconnect", href: "https://static.doubleclick.net" }),
        l.createElement("link", { rel: "preconnect", href: "https://googleads.g.doubleclick.net" })
      )
    )),
    l.createElement(
      K,
      { onPointerOver: Y, onClick: X, className: "".concat(W, " ").concat(i ? H : ""), "data-title": b, style: d(d({ backgroundImage: "url(".concat(x, ")") }, {
        "--aspect-ratio": "".concat(U / $ * 100, "%")
      }), V) },
      l.createElement("button", { type: "button", className: A, "aria-label": "".concat(M, " ").concat(b) }),
      i && l.createElement("iframe", { ref: t, className: O, title: b, width: "560", height: "315", frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: !0, src: F })
    )
  );
}
var gt = l.forwardRef(yt);
const Ct = "VideoEmbed-module_ytLite__cVhsK", kt = "VideoEmbed-module_ltyPlayBtn__LoL-A", Et = "VideoEmbed-module_lytActivated__2Bimj", C = {
  ytLite: Ct,
  ltyPlayBtn: kt,
  lytActivated: Et
};
function ne({ embed: e, video: t, caption: n, width: o, height: c, className: r }) {
  const i = P(() => {
    if (e) {
      const [u] = e.split("?");
      return u.replace("https://www.youtube.com/embed/", "");
    }
    if (t) {
      const u = t.match(/(?:\?v=|\/embed\/|\/v\/|\.be\/|\/watch\?v=)([^&?/]+)/);
      return u ? u[1] : null;
    }
    return null;
  }, [e, t]);
  return i ? /* @__PURE__ */ a(
    gt,
    {
      id: i,
      title: n || "Video Player",
      webp: !0,
      aspectWidth: o || 290,
      aspectHeight: c || 164,
      wrapperClass: p(C.ytLite, r),
      activatedClass: C.lytActivated,
      playerClass: C.ltyPlayBtn,
      noCookie: !0
    }
  ) : /* @__PURE__ */ a("div", { className: C.error, children: "Invalid YouTube video URL" });
}
const It = ({ width: e, height: t }) => /* @__PURE__ */ f("svg", { width: e, height: t, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ a("path", { d: "M16 24H32", stroke: "#44B58F", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ a(
    "path",
    {
      d: "M19.222 32H14.5C9.806 32 6 28.194 6 23.5C6 18.806 9.806 15 14.5 15H19.222",
      stroke: "#44B58F",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      d: "M28.7773 32H33.4993C38.1933 32 41.9993 28.194 41.9993 23.5C41.9993 18.806 38.1933 15 33.4993 15H28.7773",
      stroke: "#44B58F",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), xt = "CopyLink-module_wrapper__F7oCH", Bt = "CopyLink-module_icon__ijHbu", T = {
  wrapper: xt,
  icon: Bt
};
function oe({ id: e, title: t, className: n, t: o }) {
  const [c, r] = z(), i = R(() => {
    const u = location.href.split("#")[0];
    r(`${u}#${e}`);
  }, [e, r]);
  return /* @__PURE__ */ a("span", { className: p(T.wrapper, n), children: /* @__PURE__ */ a(
    "span",
    {
      className: p(T.icon, "text text-sm"),
      "data-tooltip": c != null && c.value ? (o == null ? void 0 : o("copied", "Link Copied")) ?? "Link Copied" : (t || (o == null ? void 0 : o("copyLinkForThisSection", "Copy link to this section"))) ?? "Copy link to this section",
      onClick: i,
      children: /* @__PURE__ */ a(It, {})
    }
  ) });
}
class s {
  static push(t, n = "") {
    typeof window > "u" || (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      page_id: tt(),
      page_path: window.location.pathname + n,
      user: t.user || {},
      category: "global_site",
      action: t.action || t.event,
      ...t
    }));
  }
  static pushSignUpEvent(t, n, o) {
    s.push({
      event: "sign_up",
      category: "app",
      stape_type: t,
      account_type: n,
      user: {
        email: o
      }
    });
  }
  static pushProductTrialSignUpFromPartner(t, n) {
    s.push({
      event: "sign_up",
      category: "app",
      action: "trial_sign_up_from_partner",
      productType: n,
      stape_type: "global",
      account_type: "customer",
      user: {
        email: t
      }
    });
  }
  static pushLoginEvent(t, n) {
    s.push({
      event: "login",
      category: "app",
      stape_type: t,
      account_type: n
    });
  }
  static pushProductTrialSignUpEvent(t, n, o) {
    s.push({
      event: "sign_up",
      category: "app",
      action: "trial_sign_up",
      productType: o,
      stape_type: n,
      account_type: "customer",
      user: {
        email: t
      }
    });
  }
  static pushPasswordSetEvent(t, n) {
    s.push({
      event: "password_set",
      category: "app",
      stape_type: t,
      account_type: n
    });
  }
  static pushPasswordResetEvent(t, n) {
    s.push({
      event: "password_reset",
      category: "app",
      stape_type: t,
      account_type: n
    });
  }
  static pushSearchEvent(t, n) {
    s.push({
      event: "search",
      search_term: t,
      search_results: n
    });
  }
  static pushCalculatorEvent(t) {
    s.push({
      event: "calculator",
      calc_result: t
    });
  }
  static pushContactUsClickEvent(t) {
    s.push(
      {
        event: "contact_start"
      },
      t
    );
  }
  static pushContactUsEvent() {
    s.push({
      event: "contact_submit"
    });
  }
  static pushTryForFreeClickEvent(t, n) {
    s.push(
      {
        event: "cta_click",
        page_type: "landing_page",
        button_place: t
      },
      n
    );
  }
  static pushDemoCallClickEvent() {
    s.push({
      event: "book_demo_click"
    });
  }
  static pushQuoteEvent() {
    s.push({
      event: "quote_start"
    });
  }
  static pushQuoteSubmitEvent() {
    s.push({
      event: "quote_submit"
    });
  }
  static pushMainMenuClickEvent(t) {
    s.push({
      event: "menu_click",
      menu_item: t
    });
  }
  static pushFooterLinkClickEvent(t) {
    s.push({
      event: "footer_click",
      footer_item: t
    });
  }
  static pushOnsiteLinkClickEvent(t) {
    s.push({
      event: "onsite_click",
      onsite_URL: t
    });
  }
  static pushPartnerRequestSubmitEvent(t, n) {
    s.push({
      event: "partner_request_submit",
      category: "global_site",
      action: "partner_request_submit",
      button_place: t,
      user: {
        email: n
      }
    });
  }
  static pushDemoAccountRequestSubmitEvent() {
    s.push({
      event: "demo_account_request_submit"
    });
  }
  static pushScoreScanLaunchEvent(t) {
    s.push({
      event: "score_scan_launch",
      domain: t
    });
  }
  static pushScoreContactSubmitEvent(t, n) {
    s.push({
      event: "score_contact_submit",
      domain: t,
      user: {
        email: n
      }
    });
  }
  // Helpdesk events
  static pushMainMenuHelpdeskClickEvent(t) {
    s.push({
      event: "menu_click_helpdesk",
      menu_item: t
    });
  }
  static pushFooterLinkHelpdeskClickEvent(t) {
    s.push({
      event: "footer_click_helpdesk",
      footer_item: t
    });
  }
  static pushDownloadTemplateHelpdeskClickEvent() {
    s.push({
      event: "download_template"
    });
  }
  static pushSupportHelpdeskClickEvent(t, n) {
    s.push(
      {
        event: "cta_click_helpdesk",
        page_type: "landing_page",
        button_place: t
      },
      n
    );
  }
  static pushSubscribeHelpdeskClickEvent(t, n) {
    s.push({
      action: n,
      event: "email_marketing_subscribed",
      page_type: "landing_page",
      user_email: t
    });
  }
}
const St = ({ width: e = 20, height: t = 20, fill: n = "#1E1F1E" }) => /* @__PURE__ */ f("svg", { width: e, height: t, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { background: "none" }, children: [
  /* @__PURE__ */ a("rect", { x: "1.51465", y: "0.100464", width: "26", height: "2", transform: "rotate(45 1.51465 0.100464)", fill: n }),
  /* @__PURE__ */ a("rect", { x: "0.100586", y: "18.4852", width: "26", height: "2", transform: "rotate(-45 0.100586 18.4852)", fill: n })
] }), Tt = "CloseBtn-module_close__TX-mT", Nt = {
  close: Tt
};
function Pt({ onClick: e, className: t }) {
  return /* @__PURE__ */ a("button", { className: p(Nt.close, t), type: "button", "aria-label": "Close", onClick: e, children: /* @__PURE__ */ a(St, {}) });
}
const Rt = "ModalWrapper-module_wrapper__8X45V", Mt = "ModalWrapper-module_close__f5dZQ", N = {
  wrapper: Rt,
  close: Mt
};
function se({ children: e, onClose: t, className: n }) {
  const o = Q(null), [c, r] = B(!0), [i, u] = B(!1), m = R(() => {
    r(!1), u(!1);
  }, [r]);
  return nt(i, o), D("Escape", m), Z(() => {
    const v = o.current;
    if (v)
      return S({
        targets: v,
        opacity: c ? 1 : 0,
        easing: "easeInOutSine",
        duration: 100
      }).finished.then(() => {
        c ? u(!0) : t();
      }).catch((w) => {
        console.error("Animation error:", w), c || t();
      }), () => {
        S.remove(v);
      };
  }, [o, c, t]), /* @__PURE__ */ f("div", { ref: o, className: p(N.wrapper, n), style: { opacity: 0 }, children: [
    /* @__PURE__ */ a(Pt, { onClick: m, className: N.close }),
    e
  ] });
}
const Ft = "TableOfContents-module_toc__KGeT0", Ht = "TableOfContents-module_item__flyny", Lt = "TableOfContents-module_dot__NxmbJ", Ut = "TableOfContents-module_active__XFC-u", $t = "TableOfContents-module_text__tAmle", _ = {
  toc: Ft,
  item: Ht,
  dot: Lt,
  active: Ut,
  text: $t
};
function Ot({ title: e, headings: t }) {
  const n = ot(t);
  return /* @__PURE__ */ f("div", { children: [
    /* @__PURE__ */ a("span", { className: "h4", children: e }),
    /* @__PURE__ */ a("nav", { className: _.toc, children: /* @__PURE__ */ a("ul", { children: t.map((o) => /* @__PURE__ */ a(
      "li",
      {
        className: p(_.item, "text", {
          [_.active]: n === o.elementId,
          [_.dot]: o.level === 2
        }),
        style: { marginLeft: `${(o.level - 2) * 20}px` },
        children: /* @__PURE__ */ a(wt, { color: "transparent", children: /* @__PURE__ */ a(
          "a",
          {
            href: `#${o.elementId}`,
            className: p(_.text, { [_.active]: n === o.elementId }, "text text-sm"),
            "data-text": o.text,
            children: /* @__PURE__ */ a("span", { children: o.text })
          }
        ) })
      },
      o.elementId
    )) }) })
  ] });
}
function At({ blocks: e, ...t }) {
  const n = e.reduce((o, c) => {
    var r;
    return c.type === et.Type.header && ((r = c.data) != null && r.text) && o.push({
      elementId: c.data.elementId,
      text: c.data.text,
      level: c.data.level || 2
    }), o;
  }, []);
  return n.length ? /* @__PURE__ */ a(Ot, { headings: n, ...t }) : null;
}
const ae = G(At);
export {
  wt as B,
  oe as C,
  s as D,
  pt as L,
  se as M,
  ee as R,
  ae as T,
  ne as V,
  Pt as a
};
//# sourceMappingURL=TableOfContents-DSVIeNJH.mjs.map
